/** Keep the warning alive for the upload, including after its entry UI unmounts. */
export function protectUploadFromUnload(
  target: Window | undefined = typeof window === "undefined" ? undefined : window,
) {
  const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    event.preventDefault();
    // Browsers display their own confirmation text for refresh/close navigation.
    event.returnValue = " ";
  };
  target?.addEventListener("beforeunload", handleBeforeUnload);
  return () => target?.removeEventListener("beforeunload", handleBeforeUnload);
}
